import { render } from "./TabbedConfiguration.vue?vue&type=template&id=26e47d18&scoped=true"
import script from "./TabbedConfiguration.vue?vue&type=script&lang=js"
export * from "./TabbedConfiguration.vue?vue&type=script&lang=js"

import "./TabbedConfiguration.vue?vue&type=style&index=0&id=26e47d18&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26e47d18"]])

export default __exports__